"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throwServerError = exports.THROW_SERVER_ERROR = void 0;

var _index = require("./index");

var actionType = (0, _index.actionTypeCreator)('@relient/server-error');
var THROW_SERVER_ERROR = actionType('THROW_SERVER_ERROR');
exports.THROW_SERVER_ERROR = THROW_SERVER_ERROR;

var throwServerError = function (payload, meta) {
  return {
    type: THROW_SERVER_ERROR,
    payload: payload,
    meta: meta,
    error: true
  };
};

exports.throwServerError = throwServerError;